// extracted by mini-css-extract-plugin
module.exports = {"path_blue":"order_path_blue__neWR_"};